@if (isLoading) {
  <app-rings-loader></app-rings-loader>
}
<div class="delete-confirmation-dialog">
  <div class="modal-header d-flex justify-content-start align-items-baseline border-0">
    <mat-icon class="delete-icon">delete_outline</mat-icon>
    <h3 class="dialog-title text-center mb-0">{{ 'Delete confirmation' | translate }}</h3>
  </div>
  <div mat-dialog-content class="border-0 pt-0">
    <div class="modal-body p-0">
      <p class="desc">{{confirmationMessage}}</p>
    </div>
  </div>
  <div class="modal-footer border-0" mat-dialog-actions>
    <button class="w-50 btn justify-content-center text-center confirm" (click)="mainButtonClick()">{{ 'Confirm' | translate }}</button>
    <button class="w-50 btn justify-content-center text-center cancel" mat-dialog-close
    (click)="close()">{{ 'Cancel' | translate }}</button>
  </div>
</div>